export const defaultLoadTransition = {
  transitionName: "loadComponent",
  transitionAppear: true,
  transitionEnter: false,
  transitionLeave: false,
  transitionAppearTimeout: 600,
  transitionEnterTimeout: 600,
  transitionLeaveTimeout: 200
};



// WEBPACK FOOTER //
// ./src/lib/styles/Transitions.tsx